import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © Designed &amp; Developed by{" "}
          <a href="http://zovaya.com/" target="_blank"  rel="noreferrer">
            Zovaya Corporation
          </a>{" "}
          2024
        </p>
      </div>
    </div>
  );
};

export default Footer;
